import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Media } from "@/components/Media";

const EASE = [0.16, 1, 0.3, 1];

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const y = useTransform(scrollYProgress, [0, 1], [0, 140]);

  return (
    <section id="hub" ref={ref} className="relative h-[100svh] overflow-hidden" data-testid="hero-section">
      <Media
        video="/media/hero.mp4"
        poster="/media/hero.png"
        alt="People walking in and out of the SANTELQ Hub, smiling"
        style={{ scale, y }}
        testid="hero-media"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/5 to-black/15 pointer-events-none" />

      <div className="absolute inset-x-0 bottom-14 sm:bottom-20 flex flex-col items-center text-center px-6">
        <span className="block overflow-hidden">
          <motion.h1
            initial={{ y: "120%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, ease: EASE, delay: 0.5 }}
            className="font-display font-semibold tracking-tight text-white text-2xl sm:text-3xl"
            data-testid="hero-headline"
          >
            SANTELQ
          </motion.h1>
        </span>
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: EASE, delay: 0.75 }}
          className="text-white/85 text-sm sm:text-base mt-1"
          data-testid="hero-subheadline"
        >
          Healthcare Hub
        </motion.p>
        <motion.a
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: EASE, delay: 0.95 }}
          href="#pilot"
          data-testid="hero-preorder-btn"
          className="mt-6 rounded-full bg-white text-[#3A3A3C] text-sm font-medium px-7 py-3 hover:bg-white/85 transition-colors duration-300"
        >
          Pre-Order Now
        </motion.a>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}
          className="text-white/60 text-xs mt-3"
          data-testid="hero-deposit-note"
        >
          $300 Deposit
        </motion.p>
      </div>
    </section>
  );
};
